export enum GameMetaAction {
  SET_GAME_META = "SET_GAME_META",
}

export type GameTeamMetaType = {
  teamId: string;
  nick: string;
  totalWins: number;
  totalLoss: number;
  totalTies: number;
  pointTotal: number;
};

export type GameMetaType = {
  gameId: string;
  homeTeam: GameTeamMetaType;
  visitorTeam: GameTeamMetaType;
};

interface SetGameMetaType {
  type: GameMetaAction.SET_GAME_META;
  gameMeta: GameMetaType;
}

export type GameMetaActionTypes = SetGameMetaType;
